import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect, useSelector } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import BlueprintOpener from './BlueprintOpener'
import ObjDownloader from './ObjDownloader'
import StlDownloader from './StlDownloader'
import StpDownloader from './StpDownloader'

/**
 * @param {object} args
 * @param {Function} [args.t]
 * @param {boolean} [args.isSupplierView]
 * @param {{ id: number, hasToleranceStrict?: boolean }} args.part
 */
export const DownloadFilesButtons = ({ t, isSupplierView, part: { id, hasToleranceStrict } }) => {
	const fileLinks = useSelector((/** @type {StoreState} */state) => state.CloudStorage.partsFiles?.parts?.find(p => parseInt(p.id) === id)?.fileLinks)
	const hasModifiedBlueprint = fileLinks?.modifiedBlueprint != null
	const hasStep = fileLinks?.stepModel != null
	const dontShowOriginalBlueprint = isSupplierView && hasModifiedBlueprint

	return (
		<div id={`${id}`} className="d-flex flex-row ms-3">
			{
				hasModifiedBlueprint &&
				<BlueprintOpener partId={id} isModifiedBluePrint={!isSupplierView} fileType="modifiedBlueprint" />
			}
			{!dontShowOriginalBlueprint && <BlueprintOpener partId={id} />}
			<StpDownloader partId={id} />
			{!hasStep && <StlDownloader partId={id} />}
			<ObjDownloader partId={id} />
			<div className='mt-3'>
				{hasToleranceStrict && (
					<span className="d-flex align-items-center" data-tip={t('tolerance_strict_message', { ns: 'naming' })} data-for={'hasToleranceStrictTooltip'}>
						<i className={`bx bxs-error-alt ms-1 text-yellow`}></i>
						<ReactTooltip id={'hasToleranceStrictTooltip'} place="top" type="info" effect="solid" />
					</span>
				)}
			</div>
		</div>
	)
}

const mapStateToProps = state => {
	return {
		errorCloud: state.CloudStorage.error,
		partsFiles: state.CloudStorage.partsFiles,
		isLoadingCloud: state.CloudStorage.isLoading,
	}
}

DownloadFilesButtons.propTypes = {
	t: PropTypes.func,
	part: PropTypes.object,
}

export default connect(mapStateToProps, {})(withTranslation()(DownloadFilesButtons))
